import * as React from "react";
import { observer } from "mobx-react";
import { API } from "General/API";
import { formatUserIdToName } from "utils/mentionHelpers/formatUserIdToName";
import { QACommentsView } from "./QACommentsView";
import { API_URL } from "General/APIEndpoints";
import { projectsDataStore } from "Stores/ProjectsStore";
import { qaDetailsStore } from "../Stores/QADetailsStore";

interface QAAnswerCommentsProps {
  answerId: number;
  canFetch: boolean;
}

interface QAAnswerCommentsState {
  comments: API_Comment[];
}

export const QAAnswerComments = observer(
  class QAAnswerComments extends React.Component<QAAnswerCommentsProps, QAAnswerCommentsState> {
    constructor(props: QAAnswerCommentsProps) {
      super(props);

      this.state = {
        comments: [
          // {
          //   comment: 'Test comment for display some text',
          //   id: 1,
          //   dateCreated: '523215213434',
          //   ownerId: 3
          // }
        ],
      };
    }

    componentDidMount() {
      if (this.props.canFetch) {
        (async () => await this.fetchComments())();
      }
    }

    componentDidUpdate(prevProps: QAAnswerCommentsProps) {
      if (!prevProps.canFetch && this.props.canFetch) {
        this.fetchComments();
      }
    }

    fetchComments = async () => {
      try {
        const url = API_URL.QA.answerAddComment(projectsDataStore.projectId, this.props.answerId);
        const response: API_Comment[] = await API.getData(url);
        const comments = response.map(({ comment, ...rest }) => ({ comment: formatUserIdToName(comment), ...rest }));
        this.setState({ comments: comments });
      } catch (error) {
        throw error;
      }
    };

    addComment = async (comment: string) => {
      try {
        const url = API_URL.QA.answerAddComment(projectsDataStore.projectId, this.props.answerId);
        const response: API_Comment = await API.newData(url, { comment });
        this.setState({
          comments: this.state.comments.concat({ ...response, comment: formatUserIdToName(response.comment) }),
        });
      } catch (error) {
        throw error;
      }
    };

    render() {
      const { canFetch } = this.props;
      const { comments } = this.state;
      if (!canFetch) {
        return null;
      }

      return <QACommentsView data={comments} onSubmit={this.addComment} suggestions={qaDetailsStore.suggestions} />;
    }
  }
);
